var _Path, _Path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import Svg, { Path } from "react-native-svg";

function SvgCycling(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: 34,
    height: 34,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    d: "M26.958 31a6.709 6.709 0 116.709-6.708A6.716 6.716 0 0126.958 31zm0-11.083a4.375 4.375 0 100 8.75 4.375 4.375 0 000-8.75zM7.708 31a6.709 6.709 0 116.709-6.708A6.716 6.716 0 017.708 31zm0-11.083a4.375 4.375 0 100 8.749 4.375 4.375 0 000-8.75zM22 7.667a2.326 2.326 0 002.334-2.34A2.301 2.301 0 0022.015 3a2.333 2.333 0 10-.014 4.667z",
    fill: "#333"
  })), _Path2 || (_Path2 = /*#__PURE__*/React.createElement(Path, {
    d: "M25.467 12.333h-3.19a.292.292 0 01-.256-.151L19.706 7.94a2.26 2.26 0 00-3.6-.565l-5.094 5.133a2.375 2.375 0 00-.678 1.634c0 1.268.918 1.72 1.348 1.976a232.266 232.266 0 014.345 2.56.292.292 0 01.14.248v5.04c0 .628.483 1.166 1.11 1.198A1.167 1.167 0 0018.5 24v-6.27a1.167 1.167 0 00-.485-.949l-2.698-1.94a.292.292 0 01-.043-.438l3.063-3.266a.292.292 0 01.468.058l1.591 2.871a1.167 1.167 0 001.02.6H25.5a1.169 1.169 0 001.167-1.222c-.03-.628-.572-1.11-1.2-1.11z",
    fill: "#333"
  })));
}

export default SvgCycling;